module.exports = __webpack_public_path__ + "static/agilitynotebook-8e3623bc23abe7893397cfcad39a8d8d.png";